import React from 'react';
import PropTypes from 'prop-types';

import Link from '@mui/material/Link';
import {styled} from '@mui/system';

import CopyToClipboard from '../CopyToClipboard';
import {researcherLink} from '../../helpers/links';


const StyledLink = styled(Link)(({ theme }) =>({
    fontSize: theme.custom.font.medium,
    fontHeight: theme.custom.font.line_height,
    textDecoration: 'none',
    '&:hover':{
        textDecoration: 'underline'
    }
}));


class ResearcherId extends React.Component {
    constructor(props) {
        super(props);
    }

    stopPropagation = (event) => {
        event.stopPropagation();
    };

    render() {
        return (
            <span>
                {this.props.id && <StyledLink
                    target="_blank"
                    rel="noreferrer"
                    data-bt="researcher_id"
                    onClick={this.stopPropagation}
                    href={researcherLink(this.props.id)}>
                    {this.props.id}</StyledLink>}
                {this.props.id && <CopyToClipboard value={this.props.id}/>}
            </span>
        );
    }

}

ResearcherId.propTypes = {
    id: PropTypes.string
};

export default ResearcherId;
